import React from 'react';
import { Screen } from '../App';
import { useI18n } from '../i18n';

// Persistent, unobtrusive point-of-use disclaimer shown at the bottom of every
// AI output view. Surfaces the substance of Terms of Service §2 where the teacher
// actually reads AI output, not only buried in the Terms. Links to the full Terms.

interface Props { navigate: (s: Screen) => void; }

export default function AiDisclaimer({ navigate }: Props) {
  const { t } = useI18n();
  return (
    <p style={{ fontSize: 11.5, lineHeight: 1.6, color: 'var(--text-secondary)', textAlign: 'center', marginTop: 20, padding: '0 12px' }}>
      {t('disclaimer.text')}{' '}
      <span
        onClick={() => navigate('terms')}
        style={{ color: 'var(--teal)', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
      >
        {t('disclaimer.terms')}
      </span>
    </p>
  );
}
